import {throwError as observableThrowError,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { tap, catchError } from 'rxjs/operators';
import {JsonService} from '../../../services/core/json.service';
import {ChangeOrderApiResources} from "./change-order.constants";

@Injectable({
  providedIn: 'root'
})


export class ChangeOrderDataService {
  private baseURL:any;

  constructor(
    private http: HttpClient,
    private jsonService: JsonService,
  ) {
    this.baseURL = ChangeOrderApiResources;
  }

  list(model: any): Observable<any> {
    const endPoint = `${this.baseURL.list}`;
    return this.http.post<any>(endPoint, model)
                    .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  create(model: any): Observable<any> {
    const endPoint = `${this.baseURL.create}`;
    return this.http.post<any>(endPoint, model)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  createFromJob(model: any): Observable<any> {
    const endPoint = `${this.baseURL.createFromJob}`;
    return this.http.post<any>(endPoint, model)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  detail(id: any, params?: any): Observable<any> {
    const endPoint = `${this.baseURL.detail}/${id}`;
    return this.http.get<any>(endPoint, { params })
      .pipe(
        tap(data => this.jsonService.doStringify(data)),
        catchError(this.errorHandlerMessage)
      );
  }


  update(id:any, model: any): Observable<any> {
    const endPoint = `${this.baseURL.update}/${id}`;
    return this.http.patch<any>(endPoint, model)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  delete(id:any): Observable<any> {
    const endPoint = `${this.baseURL.delete}/${id}`;
    return this.http.delete<any>(endPoint)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  // Bulk delete: DELETE change/orders/delete/multiple with { change_order_ids: [...] }
  deleteMultiple(changeOrderIds: any[]): Observable<any> {
    const endPoint = `${this.baseURL.deleteMultiple}`;
    return this.http.request<any>('delete', endPoint, { body: { change_order_ids: changeOrderIds } })
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  // Pre-check which of the selected change orders can be deleted (and why not, for the rest)
  deleteAvailability(changeOrderIds: any[]): Observable<any> {
    const endPoint = `${this.baseURL.deleteAvailability}`;
    return this.http.post<any>(endPoint, { change_order_ids: changeOrderIds })
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }
  // gets proposals
  getSetting(requestparam:any = {}): Observable<any> {
    const endPoint = `${this.baseURL.getSettings}`;
    let params = new HttpParams();
    for (const key in requestparam) {
      if (requestparam.hasOwnProperty(key)) {
        params = params.append(key, requestparam[key]);
      }
    }
    return this.http.get<any>(endPoint, {params}).pipe(tap(data=>(this.jsonService.doStringify(data))), catchError(this.errorHandlerMessage));
  }
  updateDisplayOptions(id:any, model: any): Observable<any> {
    model.loadingService = false;
    const endPoint = `${this.baseURL.updateDisplayOptions}/${id}`;
    return this.http.post<any>(endPoint, model)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  accept(id:any, model: any = []): Observable<any> {
    // model.loadingService = false;
    const endPoint = `${this.baseURL.accept.replace('{id}', id)}`;
    return this.http.post<any>(endPoint, model)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  reverse(id:any, model: any = []): Observable<any> {
    // model.loadingService = false;
    const endPoint = `${this.baseURL.reverse.replace('{id}', id)}`;
    return this.http.post<any>(endPoint, model)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  errorHandler(error: HttpErrorResponse) {
    return observableThrowError(error.error || 'Server Error');
  }
  onChangeStatus(id:any, model: any): Observable<any> {
    const endPoint = `${this.baseURL.changeStatus}/${id}`;
    return this.http.post<any>(endPoint, model)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }
  getCostDrillDown(id:any, model: any): Observable<any> {
    const endPoint = `${this.baseURL.getCostDrillDown}/${id}`;
    return this.http.post<any>(endPoint, model)
      .pipe(tap(data => (this.jsonService.doStringify(data))) , catchError(this.errorHandlerMessage));
  }

  errorHandlerMessage(error: HttpErrorResponse) {
    return observableThrowError(error.error || 'Server Error');
  }
}
